module.exports = __webpack_public_path__ + "static/media/48270850_2309074055834439_6280257087524044800_o.0d68bb9c.jpg";